import * as React from "react";
import { useTimePeriodPicker } from "../../../../../components/timePeriodAndFilterPicker/useTimePeriodPicker";
import { ChipButton } from "../../../../../components/controls/chipButton";
import { BearerTypePicker } from "../../../../../components/controls/bearerTypePicker";
import { useTranslation } from "@lib/useTypedTranslation";

import { TimePeriodPicker } from "../../../../../components/timePeriodAndFilterPicker/timePeriodAndFilterPicker";
import { DeviceInfoContext } from "../..";
import { DeviceServiceMap, MapData } from "../../../../../components/maps/intensityMaps/deviceService";

import './deviceService.css';

export const DeviceService = () => {
  const { t } = useTranslation('maps');

  const timePeriodPickerProps = useTimePeriodPicker({ timePeriods: [30, 7, 2] });

  const [selectedMapData, setSelectedMapData] = React.useState<MapData>(MapData.poorNoSignal);
  const [selectedBearer, setSelectedBearer] = React.useState<string | null>(null);

  const { id: deviceId } = React.useContext(DeviceInfoContext);

  return <div className="core-device-service">
    <div className="core-device-service_header">
      <div className="core-device-service_headings">
        <h2>{t(`${selectedMapData}_HEADING`)}</h2>
        <h3>{t(selectedMapData === MapData.coverage ? 'COVERAGE_DEVICE_SUBHEADING' : `${selectedMapData}_SUBHEADING`)}</h3>
      </div>
      <div className="core-device-service_filters">
        <div className="core-device-service_time-picker-container">
          <TimePeriodPicker {...timePeriodPickerProps} />
        </div>
        {selectedMapData === MapData.coverage &&
          <BearerTypePicker selectedBearer={selectedBearer} onChange={setSelectedBearer} />
        }
        <div className="core-device-service_radio-container">
          {Object.keys(MapData).map(key => {
            const mapData = MapData[key as keyof typeof MapData];
            return <ChipButton
              key={key}
              active={mapData === selectedMapData}
              text={t(`${mapData}_TAB`)}
              onClick={() => setSelectedMapData(mapData)}
            />;
          })}
        </div>
      </div>
    </div>
    <DeviceServiceMap
      deviceId={deviceId}
      mapData={selectedMapData}
      timePeriod={timePeriodPickerProps.timePeriod.value}
      bearerType={selectedBearer}
    />
  </div>;
};
